import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { createImageUrl } from '../../../../../../../helper/Converters';
import { useEffect, useState } from 'react';
import { translate } from '../../../../../../../utils/language';

const emptyTextSizes = ['S', 'M', 'L', 'XL'];
const emptyColors = ['black', 'yellow', 'blue', 'green'];
const VariantColors = ({ customization, staticValues, image, index, isColor, text, isActive }) => {
  return (
    <div className="flex flex-col">
      <div
        className="overflow-hidden"
        style={
          isActive
            ? {
                width: customization?.colorVariant_BoxesWidth,
                height: customization?.colorVariant_BoxesHeight,
                borderWidth: staticValues[2],
                borderColor: customization?.colorVariant_SelectedVariantBorderColor,
                color: customization?.colorVariant_VariantColorTextColor,
                borderRadius: customization?.colorVariant_BoxesBorderRadius,
                flexShrink: 0,
                padding: customization?.colorVariant_BoxesPadding,
              }
            : {
                width: customization?.colorVariant_BoxesWidth,
                height: customization?.colorVariant_BoxesHeight,
                borderWidth: staticValues[2],
                color: customization?.colorVariant_VariantColorTextColor,
                borderRadius: customization?.colorVariant_BoxesBorderRadius,
                flexShrink: 0,
                borderColor: customization?.colorVariant_DefaultVariantBorderColor,
                padding: customization?.colorVariant_BoxesPadding,
              }
        }
      >
        {customization?.colorVariant_ImageType === 'text' ? (
          <div
            className="flex w-full h-full justify-center items-center break-words "
            style={{
              color: isActive
                ? customization?.colorVariant_SelectedTextColor
                : customization?.colorVariant_DefaultTextColor,
              backgroundColor: isActive
                ? customization?.colorVariant_SelectedTextBackgroundColor
                : customization?.colorVariant_DefaultTextBackgroundColor,
            }}
          >
            {text || translate('exampleVariant')}
          </div>
        ) : isColor ? (
          <div className="w-full h-full" style={{ background: image }}></div>
        ) : (
          <img
            src={image || process.env.REACT_APP_DEFAULT_IMAGE}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        )}
      </div>
      {customization?.colorVariant_ShowVariantTitle === 'show' && (
        <div
          className="overflow-hidden truncate"
          style={{
            fontSize: customization?.colorVariant_VariantTitleTextSize,
            fontWeight: customization?.colorVariant_VariantTitleTextWeight,
            color: customization?.colorVariant_VariantTitleTextColor,
            textAlign: customization?.colorVariant_VariantTitleTextAlignment,
            fontStyle: customization?.colorVariant_VariantTitleTextStyle,
            width: customization?.colorVariant_BoxesWidth,
          }}
        >
          {text || translate('exampleVariant')}
        </div>
      )}
    </div>
  );
};

const VariantTexts = ({ customization, staticValues, text, isActive }) => {
  return (
    <div className="flex flex-col">
      <div
        className="overflow-hidden word-break truncate"
        style={{
          padding: customization?.textVariant_BoxesPadding,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderWidth: 1,
          borderColor: isActive
            ? customization?.textVariant_SelectedVariantBorderColor
            : customization?.textVariant_DefaultVariantBorderColor,
          borderRadius: customization?.textVariant_BoxesBorderRadius,
          backgroundColor: isActive
            ? customization?.textVariant_SelectedVariantBackgroundColor
            : customization?.textVariant_DefaultVariantBackgroundColor,
          width: customization?.textVariant_BoxesWidth,
          height: customization?.textVariant_BoxesHeight,
          fontSize: staticValues[12],
          color: isActive
            ? customization?.textVariant_SelectedVariantTextColor
            : customization?.textVariant_DefaultVariantTextColor,
          flexShrink: 0,
        }}
      >
        {text || translate('exampleVariant')}
      </div>
    </div>
  );
};

function Variants_1({ item }) {
  const [hashMap, setHashMap] = useState({});
  const customization = staticComponentValueConverter(item?.customization);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const products = useSelector(state => state.themeSlice.products);
  const firstVariant = products && Object.values(products)?.[0]?.data;
  const productVariantTypes = firstVariant?.productVariantTypes;
  const firsVariantHash = productVariantTypes
    ?.map(variantType => {
      const variantTypeId = variantType?.variantType?.id;
      const variantValueIds = variantType?.variantValueIds;
      return variantTypeId + variantValueIds?.[0];
    })
    ?.join(';');
  const iscolorVariant_Exists = productVariantTypes?.find(type => type?.variantType?.selectionType === 'COLOR');
  const istextVariant_Exists = productVariantTypes?.find(type => type?.variantType?.selectionType === 'CHOICE');
  console.log(iscolorVariant_Exists);
  useEffect(() => {
    const variantTypeValueArray = firstVariant?.productVariantTypes?.map(variantType => {
      const variantTypeId = variantType?.variantType?.id;
      const variantValueIds = variantType?.variantValueIds;
      return { variantTypeId, variantValueIds };
    });

    const objectMap = {};
    firstVariant?.variants?.map(variant => {
      const keyArr = [];
      const variantValues = variant?.variantValues;
      variantValues?.map(v => {
        const variantTypeId = v?.variantTypeId;
        const variantValueId = v?.variantValueId;
        const typeIndex = variantTypeValueArray?.findIndex(
          variantTypeValue => variantTypeValue?.variantTypeId === variantTypeId,
        );
        if (typeIndex !== -1) {
          keyArr[typeIndex] = variantTypeId + variantValueId;
        }
      });
      const key = keyArr?.join(';');
      objectMap[key] = variant;
    });
    setHashMap(objectMap);
  }, []);

  return (
    <div
      className=" "
      style={{
        marginRight: staticValues[10],
        marginLeft: staticValues[10],
        paddingTop: staticValues[10],
        paddingBottom: staticValues[10],
      }}
    >
      {firstVariant?.productVariantTypes?.map((type, typeIndex) => {
        const selectionType = type?.variantType?.selectionType;
        const values = type?.variantType?.values;
        const valuesLength = values?.length;
        const minLength = 4 - valuesLength;
        const defaultValuesArray = minLength > 0 ? Array.from({ length: minLength }) : [];
        console.log(defaultValuesArray);
        return (
          <>
            {selectionType === 'COLOR' ? (
              <div className="flex flex-col">
                {item?.data?.colorVariant_TitleText && (
                  <div
                    style={{
                      fontSize: customization?.colorVariant_TitleTextSize,
                      fontWeight: customization?.colorVariant_TitleTextWeight,
                      color: customization?.colorVariant_TitleTextColor,
                      textAlign: customization?.colorVariant_TitleTextAlignment,
                      fontStyle: customization?.colorVariant_TitleTextStyle,
                    }}
                  >
                    {item?.data?.colorVariant_TitleText}
                  </div>
                )}
                <div
                  className="flex flex-row  align-center  "
                  style={
                    customization?.colorVariant_DisplayMode === 'slide'
                      ? { overflowX: 'auto', whiteSpace: 'nowrap', gap: 20 }
                      : { flexWrap: 'wrap', gap: 20 }
                  }
                >
                  {type?.variantType?.values?.map((value, valueIndex) => {
                    let firsVariantHashArray = firsVariantHash?.split(';');
                    firsVariantHashArray[typeIndex] = type?.variantType?.id + value?.id;

                    const variant = hashMap[firsVariantHashArray?.join(';')];
                    if (!variant) return <></>;

                    if (customization?.colorVariant_ImageType === 'image') {
                      const image = createImageUrl(variant?.images?.[0]?.id);

                      return (
                        <VariantColors
                          staticValues={staticValues}
                          isActive={variant?.id === firstVariant?.variants?.[0]?.id}
                          customization={customization}
                          image={image}
                          index={valueIndex}
                        />
                      );
                    } else {
                      const image = value?.thumbnailImageId
                        ? createImageUrl(value?.thumbnailImageId)
                        : value?.colorCode;

                      return (
                        <VariantColors
                          staticValues={staticValues}
                          isActive={variant?.id === firstVariant?.variants?.[0]?.id}
                          customization={customization}
                          text={value?.name}
                          isColor={!value?.thumbnailImageId}
                          image={image}
                          index={valueIndex}
                        />
                      );
                    }
                  })}

                  {customization?.colorVariant_ImageType === 'image' &&
                    defaultValuesArray?.map((arr, index) => {
                      return <VariantColors staticValues={staticValues} customization={customization} image={null} />;
                    })}

                  {customization?.colorVariant_ImageType !== 'image' &&
                    defaultValuesArray?.map((arr, index) => {
                      return (
                        <VariantColors
                          staticValues={staticValues}
                          customization={customization}
                          isColor={true}
                          image={emptyColors[index]}
                        />
                      );
                    })}
                </div>
              </div>
            ) : (
              <div className="flex flex-col">
                <div
                  style={{
                    fontSize: customization?.textVariant_TitleTextSize,
                    fontWeight: customization?.textVariant_TitleTextWeight,
                    color: customization?.textVariant_TitleTextColor,
                    textAlign: customization?.textVariant_TitleTextAlignment,
                    fontStyle: customization?.textVariant_TitleTextStyle,
                  }}
                >
                  {item?.data?.textVariant_TitleText}
                </div>
                <div
                  className="flex flex-row  align-center  "
                  style={
                    customization?.textVariant_DisplayMode === 'slide'
                      ? { overflowX: 'auto', whiteSpace: 'nowrap', gap: 20 }
                      : { flexWrap: 'wrap', gap: 20 }
                  }
                >
                  {type?.variantType?.values?.map((value, valueIndex) => {
                    let firsVariantHashArray = firsVariantHash?.split(';');
                    firsVariantHashArray[typeIndex] = type?.variantType?.id + value?.id;

                    const variant = hashMap[firsVariantHashArray?.join(';')];
                    if (!variant) return <></>;
                    return (
                      <VariantTexts
                        isActive={
                          variant?.id === firstVariant?.variants?.[0]?.id || (typeIndex !== 0 && valueIndex === 0)
                        }
                        customization={customization}
                        text={value?.name}
                        staticValues={staticValues}
                      />
                    );
                  })}
                  {defaultValuesArray?.map((arr, index) => {
                    return <VariantTexts isActive={true} customization={customization} staticValues={staticValues} />;
                  })}
                </div>
              </div>
            )}
          </>
        );
      })}

      {!iscolorVariant_Exists && (
        <div className="flex flex-col">
          {item?.data?.colorVariant_TitleText && (
            <div
              style={{
                fontSize: customization?.colorVariant_TitleTextSize,
                fontWeight: customization?.colorVariant_TitleTextWeight,
                color: customization?.colorVariant_TitleTextColor,
                textAlign: customization?.colorVariant_TitleTextAlignment,
                fontStyle: customization?.colorVariant_TitleTextStyle,
              }}
            >
              {item?.data?.colorVariant_TitleText}
            </div>
          )}
          <div
            className="flex flex-row  align-center "
            style={
              customization?.colorVariant_DisplayMode === 'slide'
                ? { overflowX: 'auto', whiteSpace: 'nowrap', gap: 20 }
                : { flexWrap: 'wrap', gap: 20 }
            }
          >
            {customization?.colorVariant_ImageType === 'image' && (
              <>
                <VariantColors staticValues={staticValues} isActive={true} customization={customization} image={null} />
                <VariantColors staticValues={staticValues} customization={customization} image={null} />
                <VariantColors staticValues={staticValues} customization={customization} image={null} />
                <VariantColors staticValues={staticValues} customization={customization} image={null} />
              </>
            )}

            {customization?.colorVariant_ImageType !== 'image' && (
              <>
                {emptyColors?.map((color, index) => {
                  <VariantColors
                    staticValues={staticValues}
                    isActive={index === 0}
                    customization={customization}
                    isColor={true}
                    image={color}
                  />;
                })}
              </>
            )}
          </div>
        </div>
      )}
      {!istextVariant_Exists && (
        <div className="flex flex-col">
          <div
            style={{
              fontSize: customization?.textVariant_TitleTextSize,
              fontWeight: customization?.textVariant_TitleTextWeight,
              color: customization?.textVariant_TitleTextColor,
              textAlign: customization?.textVariant_TitleTextAlignment,
              fontStyle: customization?.textVariant_TitleTextStyle,
            }}
          >
            {item?.data?.textVariant_TitleText}
          </div>
          <div
            className="flex flex-row  align-center"
            style={
              customization?.textVariant_DisplayMode === 'slide'
                ? { overflowX: 'auto', whiteSpace: 'nowrap', gap: 20 }
                : { flexWrap: 'wrap', gap: 20 }
            }
          >
            <VariantTexts isActive={true} customization={customization} staticValues={staticValues} />
            <VariantTexts customization={customization} staticValues={staticValues} />
            <VariantTexts customization={customization} staticValues={staticValues} />
            <VariantTexts customization={customization} staticValues={staticValues} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Variants_1;
